/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intakeheading1Inputs */

const en_intakeheading1 = /** @type {(inputs: Intakeheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step 1 — Upload your documents`)
};

const pt_intakeheading1 = /** @type {(inputs: Intakeheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passo 1 — Carregue os seus documentos`)
};

/**
* | output |
* | --- |
* | "Step 1 — Upload your documents" |
*
* @param {Intakeheading1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const intakeheading1 = /** @type {((inputs?: Intakeheading1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intakeheading1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intakeheading1(inputs)
	return pt_intakeheading1(inputs)
});
export { intakeheading1 as "intakeHeading" }